import React, { useState } from 'react';
import EditableLabel from './EditableLabel';
import { GridNode, GeodataNode, SimulationNode, SubSimulation } from 'types/project';

type EditableLabelStateProps = {
  item: GridNode | GeodataNode | SimulationNode | SubSimulation | Record<string, any>;
  onSave: (value: string) => Promise<unknown>;
  useTruncation?: boolean;
  onSingleClick?: () => void;
  maxLength?: number;
};

const EditableLabelState: React.FC<EditableLabelStateProps> = ({
  item,
  onSave,
  useTruncation = false,
  onSingleClick,
  maxLength,
}) => {
  const [name, setName] = useState(item.name || 'No Name');

  return (
    <EditableLabel
      label={name}
      item={item}
      onEdit={setName}
      onSave={onSave}
      onSingleClick={onSingleClick}
      useTruncation={useTruncation}
      maxLength={maxLength}
    />
  );
};

export default EditableLabelState;
